var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAward(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.2617 3.23813L29.9992 0L23.7367 3.23813L16.7711 4.29938L13.6155 10.5994L8.60547 15.5494L9.74922 22.5L8.60547 29.4506L13.6155 34.4006L16.7711 40.7006L23.7367 41.7619L29.9992 45L36.2617 41.7619L43.2273 40.7006L46.383 34.4006L51.393 29.4506L50.2492 22.5L51.393 15.5494L46.383 10.5994L43.2273 4.29938L36.2617 3.23813ZM40.743 7.71187L43.308 12.8306L47.3805 16.8525L46.4486 22.5L47.3805 28.1475L43.308 32.1675L40.743 37.2863L35.0805 38.145L29.9992 40.7738L24.918 38.145L19.2555 37.2881L16.6905 32.1694L12.618 28.1475L13.5498 22.5L12.6123 16.8525L16.6905 12.8325L19.2555 7.71375L24.918 6.855L29.9992 4.22625L35.0805 6.855L40.743 7.71187Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 44.2312V60L30 56.25L45 60V44.2312L37.4344 45.375L30 49.2243L22.5656 45.3712L15 44.2312Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/award.02fba69eba4db72ad22a4bf120537adb.svg";
export { ForwardRef as ReactComponent };